export function formatSecondsToTime(timeInSeconds: number, showSeconds = false) {
  const hours = Math.floor(timeInSeconds / (1000 * 60 * 60));
  const minutes = Math.floor((timeInSeconds % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeInSeconds / 1000) % 60);

  const timeArray = [];

  if (hours) {
    timeArray.push(hours);
  }

  timeArray.push(minutes);

  if (showSeconds) {
    timeArray.push(seconds);
  }
  return { time: timeArray.map((num) => num.toString().padStart(2, '0')).join(':'), timeArray };
}
